/**
 * Removes common Markdown emphasis/heading syntax from a string so it can be
 * shown as plain text without literal `*`, `_`, `#`, or backtick characters
 * leaking through. Use this for surfaces that can't render Markdown (e.g. the
 * global search results, which inject Algolia highlight HTML and therefore
 * can't be passed through a Markdown renderer).
 */
export function stripMarkdown(input: string): string {
  if (!input) return input;
  return (
    input
      // bold/italic markers: **text**, __text__, *text*, _text_
      .replace(/(\*\*|__|\*|_)(.*?)\1/g, "$2")
      // any stray, unmatched emphasis markers
      .replace(/\*+/g, "")
      // leading heading hashes ("## Title" -> "Title")
      .replace(/^#{1,6}\s+/gm, "")
      // inline code backticks
      .replace(/`/g, "")
  );
}

export default stripMarkdown;
